const UserRelationReport = {

	visual: {
		icon: "va-icon fa fa-users",
		title: "User Relation Report",
		desc: "Analysis of the relation between two accounts"
	},

	binding: [
	{"user_relation_acc_1": "string","label":"First screen name"},
	{"user_relation_acc_2": "string","label":"Second screen name"},
	{"user_relation_limit_2": "number", "label":"Return limit"},
	{"status_created_at_from": "date","label":"Status ('retweets'|'posted') created from"},
	{"status_created_at_to": "date","label":"Status ('retweets'|'posted') created to"},
	
	],

	query:`
	MATCH 
		(a1:Account {screen_name: ':user_relation_acc_1'})-[r1:POSTED | :RETWEETED | :MENTIONED_BY ]->(s:Status)<-[r2:POSTED | :RETWEETED | :MENTIONED_BY ]-(a2:Account {screen_name: ':user_relation_acc_2'}) 
	WHERE
		date(s.created_at) >= date(':status_created_at_from') AND date(s.created_at) <= date(':status_created_at_to')
	RETURN 
		a1, r1, s, r2, a2 LIMIT :user_relation_limit_2
	`,

	config:{
		console_debug:true,
		labels: {
			"Account":{
				"caption": "screen_name"
			},
			"Status": {
				"caption": false
			}
		},
		relationships: {
			"POSTED": {
				"thickness": "count",
				"caption": false
			}
		},
	}
	
}

export default UserRelationReport;
